// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DeleteOutlinedSvg from "@ant-design/icons-svg/lib/asn/DeleteOutlined";
import AntdIcon from "../components/AntdIcon";
const DeleteOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DeleteOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DeleteOutlined.displayName = "DeleteOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DeleteOutlined);
